/**
 * @param {Array} organizations
 * @param {string=} orderField
 * @param {string=} orderDirection
 * @param {function} onOrder
 * @param {boolean} rowsDisabled
 * @param {function} onDelete
 * @param {function} onAutoLogin
 * @param {function} onShowDetails
 * @param {function} onRefreshIntercomTags
 */
import React from "react";
import SortableTh from "../../theme/untitled/SortableTh/SortableTh";
import TableRow from "./TableRow";
import styles from "./OrganizationsPage.module.scss";

// Only name/plan/expiry are in the backend's real order whitelist
// (Form/Organizations/IndexForm.php's `inList`) — Treasury email and
// First subscription have no server-side sort support, so they're
// non-interactive columns here rather than silently 400ing on click.
const COLUMNS = [
  { key: "name", label: "Name", orderField: "name" },
  { key: "status", label: "Status", className: styles.colStatus },
  { key: "email", label: "Treasury email", className: styles.colEmail },
  { key: "users", label: "Users", className: styles.colUsers },
  { key: "owner", label: "Owner account", className: styles.colOwner },
  {
    key: "first_subscription",
    label: "First subscription",
    className: styles.colDate,
  },
  { key: "plan", label: "Plan", orderField: "plan", className: styles.colPlan },
  {
    key: "expiry",
    label: "Plan expires",
    orderField: "expiry",
    className: styles.colDate,
  },
];

const OrganizationsTable = ({
  organizations,
  orderField,
  orderDirection,
  onOrder,
  rowsDisabled,
  onDelete,
  onAutoLogin,
  onShowDetails,
  onRefreshIntercomTags,
}) => {
  const cols = COLUMNS.slice(1).map((col) => (
    <col key={col.key} className={col.className} />
  ));

  const headerCells = COLUMNS.map((col) => (
    <SortableTh
      key={col.key}
      orderField={col.orderField}
      currentDirection={orderField === col.orderField ? orderDirection : null}
      onOrder={onOrder}
    >
      {col.label}
    </SortableTh>
  ));

  const rows = organizations.map((organization) => (
    <TableRow
      key={organization.uuid}
      organization={organization}
      disabled={rowsDisabled}
      onDelete={onDelete}
      onAutoLogin={onAutoLogin}
      onShowDetails={onShowDetails}
      onRefreshIntercomTags={onRefreshIntercomTags}
    />
  ));

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <colgroup>
          <col />
          {cols}
          <col className={styles.colActions} />
        </colgroup>
        <thead>
          <tr>
            {headerCells}
            <th scope="col" aria-hidden="true" />
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default OrganizationsTable;
